import { faFileInvoice } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme: Theme): StyleRules => ({
  empty: {
    textAlign: 'center'
  },
  emptyInvoice: {
    margin: theme.spacing(5),
    color: theme.palette.icon.file
  }
});

type BillingTableLabelProps = WithStyles<typeof styles>;

const BillingTableLabel: React.FC<BillingTableLabelProps> = ({ classes }) => (
  <div className={classes.empty}>
    <FontAwesomeIcon
      icon={faFileInvoice}
      size="3x"
      className={classes.emptyInvoice}
    />
    <Typography variant="subtitle1" color="textSecondary">
      請求書はありません。
    </Typography>
  </div>
);

export default withStyles(styles)(BillingTableLabel);
